import React, {useContext, useEffect, useState} from 'react'
import MUIDataTable from 'mui-datatables'
import api from '../../../services/api'
import { DataTableOptions } from '../../../components/dataTableOptions'
import {MainContext} from "../../../context/MainContext";
import Swal from "sweetalert2";
import {AuthContext} from "../../../context/AuthContext";

export default function ListingAttendances({ filter }:any) {
  const { setLoading } = useContext(MainContext)
  const [attendances, setAttendances] = useState([] as any)
  const { authUser } = useContext(AuthContext)

  function deleteAttendance(id:any) {
    Swal.fire({
      title: 'Tem certeza que deseja excluir a presença?',
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#198754",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar"
    }).then((result) => {
      if (result.isConfirmed) {
        try{
          setLoading(true)
          api['delete'](`/api/presence/destroy/${id}`)
              .then((result) => {
                setLoading(false)
                Swal.fire({
                  title: 'Sucesso!',
                  text: result.data.message,
                  icon: 'success',
                  timer: 3000,didClose: () => {
                    getAttendances()
                  }
                }).then(() => setLoading(false));
              })
              .catch(erro => {
                setLoading(false)
                Swal.fire({
                  title: 'Erro!',
                  text: erro.response.data.message,
                  icon: 'error',
                });
              });
        }catch (err: any) {
          setLoading(false)
          Swal.fire({
            title: 'Erro!',
            text: err,
            icon: 'error',
          })
        }
      }
    });
  }

  const getAttendances = async () => {
    await api.post(`/api/app/presence/report`, {filtro: filter}).then((response) => {
      setAttendances(response.data)
    }).then(() => {
      setLoading(false)
    });
  }

  useEffect(() => {
    setLoading(true)
    const fetchData = async () => {
      await getAttendances()
    };

    fetchData().then(setLoading(false))
  }, [])

  const columns: any = [
    {
      name: 'capture_timestamp', label: 'Data', options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any) => {
          return value ? new Date(value).toLocaleString('pt-BR') : '';
        }
      },
    },{
      name: 'quantity_shots', label: 'Qtd. Tiros', options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: '', label: '', options: {
        filter: false,
        false: true,
        customBodyRenderLite: (index: string | number) => { return (
            <>
               {(['coordinator', 'admin'].includes(authUser?.role)) && (
                  <button type="button" className="btn btn-sm btn-danger" title="Excluir"
                    onClick={() => deleteAttendance(attendances[index]?.id)}>
                    <i className="bi bi-trash" aria-hidden="true"></i>
                  </button>
               )}
            </>

        )
        },
      },
    },
  ]

  let options: any = DataTableOptions
  options.search = false

  return (
      <>
        <div className='mb-4 mui-dense'>
          <MUIDataTable
              title={'Presenças'}
              data={attendances}
              columns={columns}
              options={options}
          />
        </div>
      </>
  )
}
